import React, { ComponentType, PropsWithChildren } from 'react';
import { MetaTagConfig } from './metaTagConfig';

const renderMetaRobots = (noindex?: boolean, nofollow?: boolean) => {
  if (!noindex) {
    return null;
  }
  const content = ['noindex', nofollow ? 'nofollow' : 'follow'].join(', ');
  return <meta content={content} name="robots" />;
};

export interface PageMetaTagsProps {
  tagsConfig?: MetaTagConfig[];
  /** @deprecated */
  isClosedForRobots?: boolean;
  noindex?: boolean;
  nofollow?: boolean;
  /** Component to render Head like react-helmet */
  HeadComponent: ComponentType<PropsWithChildren>;
}
export const PageMetaTags = ({ HeadComponent, tagsConfig, noindex, nofollow, isClosedForRobots }: PageMetaTagsProps) => (
  <HeadComponent>
    {tagsConfig?.map(({ tagName, tagContent }) => {
      if (tagName === 'title') {
        return <title key={tagName}>{tagContent}</title>;
      }

      return <meta content={tagContent} key={tagName} name={tagName} />;
    })}
    {isClosedForRobots ? renderMetaRobots(true, true) : renderMetaRobots(noindex, nofollow)};
  </HeadComponent>
);
